import { Component, input } from '@angular/core';
import { TranslateDirective, TranslatePipe as NgxTranslatePipe } from '@ngx-translate/core';

import { ModalNotificationImageDirective } from '../../image/modal-notification-image.directive';

@Component({
  imports: [
    TranslateDirective,
    NgxTranslatePipe,
    ModalNotificationImageDirective
  ],
  selector: 'td-wb-modal-notification-welcome-modal-di',
  templateUrl: 'modal-notification-welcome-modal-di.component.html',
  styleUrls: [
    '../modal-notification-common.component.scss'
  ]
})
export class ModalNotificationWelcomeModalDiComponent {
  readonly currentPage = input(0);
}
